module.exports = {"Config":{"DESENVOLVEDOR":"dev","LEILOEIRO":"giordanoleiloes","PORT":8080}}


//////////////////
// WEBPACK FOOTER
// ./config/configuracao-ambiente-npm-dev.json
// module id = r3vH
// module chunks = 1